import style from './style';

const LoadingScreen = () => (
    <div class={style['loading-screen']}>
        загрузка...
    </div>
);

export default LoadingScreen;
